<template>
  <mdb-container class="gp-has-header" v-if="settings.features.contactUs">
  <mdb-card class="text-left">
    <mdb-card-header class="secondary-color">
      <h4>Contact Us</h4>
    </mdb-card-header>
    <mdb-card-body v-if="!submitSuccess">
      <div v-if="!loggedIn">
        If you're a registered user, please
        <router-link to="/login">login first</router-link> so we may better respond.
      </div>
      <mdb-input v-if="!loggedIn" label="Email Address" placeholder="Your Email" v-model="message.fromEmail"/>
      <mdb-input v-if="loggedIn && !createAsIssue" disabled label="Email Address" v-model="userDetails.email"/>
      <gp-select :dataObj="message" :possible-values="reasons" :required="true"
      label="Subject" propertyName="reason"/>
      <gp-select :dataObj="message" :possible-values="groups" v-if="groups && groups.length>0 && !createAsIssue"
                 placeholder="Select a group if your message is related to a specific group you manage."
                 label="Group" propertyName="group"/>
      <div class="text-info mb-2">
        This contact form is for issues with the {{settings.siteName}} platform. If you have question about a group you
        belong to or are trying to join, please contact the group's admin directly.
      </div>
      <h4>Your Message</h4>
      <editor :init="editorConfig" v-model="message.body"/>
      <mdb-btn :disabled="!validForm" @click="submitMessage" icon="mailbox" color="success">Send Message</mdb-btn>

    </mdb-card-body>
    <mdb-card-body v-if="submitSuccess">
      <h5 v-if="!issueId">Your message has been sent.</h5>
      <div v-if="issueId">
          <h4>Success</h4>
          <p>Your message has been sent via our issue tracking system. You may track the status of your request
            or add additional details <router-link :to="'/issues/show/' + issueId">here</router-link>.

          </p>
      </div>
    </mdb-card-body>
  </mdb-card>


  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import editor from '@tinymce/tinymce-vue'
import gpSelect from "./common/GPSelect";
import {
  mdbAccordion,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader
} from 'mdbvue';

export default {
    name: 'Contact-Form',
    components: {
      mdbAccordion,
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbInput,
      mdbBtn,
      gpSelect,
      editor
    },
    watch: {
      userDetails(n) {
        console.log(n)
        if (n) this.populateGroups()
      }
    },
    data() {
      return {
        issueId: null,
        submitSuccess: false,
        message: {
          fromEmail: "",
          body: "",
          reason: "",
          group: null,
          user: null
        },
        reasons: [{text: "Technical Problem", value: "Technical"},
          {text: "Billing Issue", value: "Billing"},
          {text: "Report SPAM/Solicitation", value: "SPAM/Solicitation"},
          {text: "Report Issue with a Person", value: "Person Issue"},
          {text: "Report Random Messaging from a member(s)", value: "Random Messaging"},
          {text: "Send us a Compliment", value: "Compliment"},
          {text: "Other", value: "Other"}
        ],
        groups: null,
        editorConfig: {
          browser_spellcheck: true,
          branding: false,
          plugins: ["image", "link", "code", "paste", "table", "lists"],
          toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
          image_advtab: true,
          style_formats_merge: true,
          paste_as_text: true,
          paste_data_images: false,
          relative_urls: false,
          remove_script_host: false,
          height: 400
        }
      }
    },
    computed: {
      loggedIn: function() {
        return this.$store.state.loggedIn
      },
      userDetails: function () {
        return this.$store.state.userDetails
      },
      settings: function () {
        return this.$store.state.settings
      },
      validForm: function() {
        if (!this.loggedIn && !this.message.fromEmail) return false
        if (!this.createAsIssue && !this.message.reason) return false
        if (!this.message.reason) return false
        if (!this.message.body) return false
        return true
      },
      createAsIssue: function() {
        if (!this.loggedIn) return false
        if (this.settings.features.issueTracker && this.settings.features.usersSeeIssues) {
          return true
        }
        return false
      }
    },
    mounted() {
      if (this.userDetails) this.populateGroups()
    },
    methods: {
      populateGroups() {
        this.message.user = this.userDetails.id
        this.message.email = this.userDetails.email
        this.groups = []
        for (let i=0; i<this.userDetails.groups.length; i++) {
          let group = this.userDetails.groups[i]
          if (group.isOwner) this.groups.push( {text: group.name, value: group.id})
        }
      },
      submitMessage() {
        this.$store.dispatch("setExecuting", true)
        let url = "/public/contactMessage/"
        api.post(url, this.message).then(
          (results) => {
            if (results.data.issueCreated && results.data.issueId) {
              this.issueId = results.data.issueId
            }
            this.submitSuccess = true
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  };
</script>
